import { STATE_LIST } from '../constants/StateList.js';

const getStateListByIds = (routeIds) => {
    return routeIds === null || routeIds === void 0 ? void 0 : routeIds.map((routeId) => {
        return STATE_LIST.find((stateId) => stateId.id === routeId.id);
    });
};

export { getStateListByIds };
//# sourceMappingURL=getStateListByIds.js.map
